(() => {
  const API = 'https://technogold-avisos.ayrtonmarin1205.workers.dev';
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const feeds = new Map();
  function catalog(context) {
    const params = new URLSearchParams({language:context.dataset.language,country:context.dataset.country});
    const key = params.toString();
    if (!feeds.has(key)) feeds.set(key, fetch(API+'/discover?'+key,{credentials:'omit',signal:AbortSignal.timeout(15000)}).then(response=>{
      if (!response.ok) throw new Error('feed');
      return response.json();
    }));
    return feeds.get(key);
  }
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  function scrollCue(shell) {
    if (shell.dataset.tgReady) return;
    const track = shell.querySelector('[data-tg-scroll]'), next = shell.querySelector('[data-tg-next]');
    if (!track || !next) return;
    shell.dataset.tgReady = 'true';
    const update = () => {
      const overflow = track.scrollWidth > track.clientWidth + 5;
      next.hidden = !overflow;
      const end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      next.textContent = end ? '←' : '→';
      next.dataset.end = String(end);
    };
    track.addEventListener('scroll', update, {passive:true});
    next.addEventListener('click', () => track.scrollTo({left:next.dataset.end === 'true' ? 0 : track.scrollLeft + track.clientWidth * .9,behavior:reduceMotion ? 'auto' : 'smooth'}));
    new ResizeObserver(update).observe(track);
    new MutationObserver(update).observe(track, {childList:true});
    update();
  }
  function brands(section, counts) {
    const grid = section.querySelector('.tg-brands__grid'), button = section.querySelector('[data-tg-brands-toggle]');
    const cards = [...grid.children];
    if (counts) cards.forEach(card => {
      if (card.dataset.brand !== '__other__') card.dataset.count = card.dataset.brand.split('|').reduce((sum, vendor) => sum + (counts[vendor] || 0), 0);
    });
    cards.sort((a,b) => (a.dataset.brand==='__other__')-(b.dataset.brand==='__other__') || Number(b.dataset.count)-Number(a.dataset.count) || a.textContent.trim().localeCompare(b.textContent.trim()));
    cards.forEach((card,index) => {card.classList.toggle('tg-brand--extra',index>=20);grid.append(card);});
    if (!button.dataset.ready) {
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const expanded = section.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = (expanded ? button.dataset.less : button.dataset.more) + (expanded ? ' −' : ' ＋');
        if (!expanded && section.getBoundingClientRect().top < 0) section.scrollIntoView({block:'start',behavior:reduceMotion?'auto':'smooth'});
      });
    }
  }
  function drawerBrands(counts) {
    document.querySelectorAll('.tg-drawer-brands').forEach(list=>{
      const cards=[...list.children].filter(card=>card.matches('[data-brand]'));
      if(counts) cards.forEach(card=>{
        if(card.dataset.brand!=='__other__')card.dataset.count=card.dataset.brand.split('|').reduce((sum,vendor)=>sum+(counts[vendor]||0),0);
      });
      cards.sort((a,b)=>(a.dataset.brand==='__other__')-(b.dataset.brand==='__other__')||Number(b.dataset.count)-Number(a.dataset.count)||a.dataset.brand.localeCompare(b.dataset.brand));
      cards.forEach(card=>list.append(card));
    });
  }
  function syncBrandCounts(counts) {
    document.querySelectorAll('[data-tg-brands]').forEach(section=>brands(section,counts));
    drawerBrands(counts);
  }
  function logoFallbacks() {
    document.querySelectorAll('.tg-brand-logo').forEach(img=>{
      if(img.dataset.tgReady)return;
      img.dataset.tgReady='true';
      const fallback=()=>img.parentElement.replaceWith(el('span','tg-brand-wordmark',img.alt));
      img.addEventListener('error',fallback,{once:true});
      if(img.complete&&!img.naturalWidth)fallback();
    });
  }
  function mixedNewProducts(products) {
    const groups = new Map();
    products=products.filter(p=>!/(?:\bPDF\b|user[ -]manual|manual-de-usuario)/i.test(p.title+' '+p.handle));
    for (const p of products) {
      const key = p.productType || p.vendor;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(p);
    }
    const keys = [...groups.keys()];
    for(let i=keys.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[keys[i],keys[j]]=[keys[j],keys[i]];}
    const result = [];
    // Keep the latest arrival visible, then rotate categories, newest within each.
    if(products.length){result.push(products[0]);groups.get(products[0].productType||products[0].vendor).shift();}
    while(result.length<20 && keys.some(key=>groups.get(key).length)){
      for(const key of keys){if(result.length>=20)break;const p=groups.get(key).shift();if(p)result.push(p);}
    }
    return result;
  }
  function featuredTrending(data) {
    const isApparatus=p=>!/(?:\bPDF\b|user[ -]manual|manual-de-usuario)/i.test(p.title+' '+p.handle);
    const popular=data.trending.filter(isApparatus).slice(0,20);
    const seen=new Set(popular.map(p=>p.id));
    const remaining=data.newest.filter(p=>isApparatus(p)&&!seen.has(p.id));
    for(let i=remaining.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[remaining[i],remaining[j]]=[remaining[j],remaining[i]];}
    return popular.concat(mixedNewProducts(remaining)).slice(0,20);
  }
  function productCard(p, section) {
    const root=section.dataset.root.replace(/\/$/, '');
    const card=el('a','tg-product');
    card.href=root+'/products/'+encodeURIComponent(p.handle);
    card.dataset.productId=p.id.split('/').pop();
    const photo=el('div','tg-product__photo');
    if(p.featuredImage?.url?.startsWith('https://cdn.shopify.com/')){
      const img=el('img');const url=new URL(p.featuredImage.url);url.searchParams.set('width','540');
      img.src=url.href;img.alt=p.featuredImage.altText || p.title;img.loading='lazy';img.width=540;img.height=540;photo.append(img);
    }
    card.append(photo,el('span','tg-product__vendor',p.vendor),el('h3','tg-product__title',p.title));
    const money=p.priceRange.minVariantPrice;
    card.append(el('span','tg-product__price',new Intl.NumberFormat(section.dataset.language,{style:'currency',currency:money.currencyCode}).format(Number(money.amount))));
    return card;
  }
  function allCard(section,text) {
    const card=el('a','tg-product tg-product--all');
    card.href=section.querySelector('[data-tg-view-all]').href;
    const arrow=el('span','tg-product__round-arrow','→');arrow.setAttribute('aria-hidden','true');
    card.append(arrow,el('strong','',text.all),el('small','',text.explore));
    return card;
  }
  async function discover(section) {
    if(section.dataset.ready)return;section.dataset.ready='true';
    const text=JSON.parse(section.querySelector('[data-tg-discover-text]').textContent);
    const tabs=[...section.querySelectorAll('[data-tg-tab]')];
    const activate=tab=>{
      for(const item of tabs){const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;}
      section.querySelectorAll('[data-tg-panel]').forEach(panel=>panel.hidden=panel.dataset.tgPanel!==tab.dataset.tgTab);
    };
    tabs.forEach((tab,i)=>{
      tab.addEventListener('click',()=>activate(tab));
      tab.addEventListener('keydown',e=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
        e.preventDefault();const target=tabs[e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+1)%tabs.length];activate(target);target.focus();
      });
    });
    try {
      const data=await catalog(section);
      if(!Array.isArray(data.newest)||!Array.isArray(data.trending))throw new Error('feed');
      if(data.countsReady)syncBrandCounts(data.counts);
      for(const key of ['newest','trending']){
        const track=section.querySelector('[data-tg-panel="'+key+'"] [data-tg-scroll]');
        const products=key==='newest'?mixedNewProducts(data.newest):featuredTrending(data);
        track.replaceChildren(...products.map(p=>productCard(p,section)));
        if(!products.length)track.append(el('p','tg-discover__notice',key==='trending'?text.empty:text.error));
        if(key==='newest' && products.length)track.append(allCard(section,text));
      }
    } catch {
      section.querySelectorAll('.tg-products').forEach(track=>track.replaceChildren(el('p','tg-discover__notice',text.error)));
    }
  }
  function nativeCues() {
    if(innerWidth>749)return;
    document.querySelectorAll('.swiper').forEach(swiper=>{
      if(swiper.closest('.tg-home')||swiper.querySelector('.tg-native-scroll-cue'))return;
      if(!swiper.querySelector('.swiper-slide'))return;
      const cue=el('span','tg-native-scroll-cue','→');cue.setAttribute('aria-hidden','true');swiper.append(cue);
      const update=()=>{const s=swiper.swiper;cue.hidden=s?!!s.isLocked:swiper.querySelectorAll('.swiper-slide').length<2;cue.textContent=s?.isEnd&&!s.params.loop?'←':'→';};
      update();if(swiper.swiper)swiper.swiper.on('slideChange resize',update);
    });
  }
  function drawerHints(){
    document.querySelectorAll('.tg-drawer-brands').forEach(list=>{
      if(list.dataset.tgReady)return;list.dataset.tgReady='true';
      const hint=list.nextElementSibling;if(!hint?.classList.contains('tg-drawer-scroll-hint'))return;
      const update=()=>{hint.hidden=list.scrollHeight<=list.clientHeight+5;hint.querySelector('span').textContent=list.scrollTop+list.clientHeight>=list.scrollHeight-8?'↑':'↓';};
      list.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(list);update();
    });
  }
  function trackProduct(){
    const node=document.querySelector('[data-tg-view-product]');
    if(!node || window.Shopify?.designMode || window.Shopify?.theme?.role!=='main')return;
    let sent=false,timer;
    const send=async()=>{
      if(sent||document.visibilityState!=='visible'||!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed())return;
      const key='tg-view-'+node.dataset.tgViewProduct;
      try{if(sessionStorage.getItem(key))return;}catch{}
      sent=true;
      try{
        const r=await fetch(API+'/view',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:node.dataset.tgViewProduct}),credentials:'omit',keepalive:true});
        if(r.ok){try{sessionStorage.setItem(key,'1');}catch{}}else sent=false;
      }catch{sent=false;}
    };
    const schedule=()=>{clearTimeout(timer);if(document.visibilityState==='visible')timer=setTimeout(send,5000);};
    document.addEventListener('visitorConsentCollected',schedule);
    document.addEventListener('visibilitychange',schedule);
    if(window.Shopify?.customerPrivacy)schedule();
    else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)schedule();});
  }
  function init(){
    document.querySelectorAll('[data-tg-brands]').forEach(s=>brands(s));
    drawerBrands();logoFallbacks();
    const drawer=document.querySelector('.tg-drawer-brands');
    if(drawer&&!document.querySelector('[data-tg-discover]'))catalog(drawer).then(data=>{if(data.countsReady)syncBrandCounts(data.counts);}).catch(()=>{});
    document.querySelectorAll('.tg-scroll-shell').forEach(scrollCue);
    document.querySelectorAll('[data-tg-discover]').forEach(discover);
    drawerHints();nativeCues();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init();trackProduct();},{once:true});else{init();trackProduct();}
  window.addEventListener('load',nativeCues,{once:true});
  window.addEventListener('resize',nativeCues);
  document.addEventListener('shopify:section:load',init);
})();
